import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Your Firebase config
const firebaseConfig = {
    apiKey: "AIzaSyCIsM3xWu1ws1ijXvAqfeDFUbDl0dkDhy8",
    authDomain: "kolaydoy-e551a.firebaseapp.com",
    projectId: "kolaydoy-e551a",
    storageBucket: "kolaydoy-e551a.firebasestorage.app",
    messagingSenderId: "919044739997",
    appId: "1:919044739997:web:c74aa30bc2ae5371281574"
};

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Initialize messaging only if the environment supports service workers
let messaging;
if ('serviceWorker' in navigator) {
    try {
        messaging = getMessaging(app);

        // Listen for incoming messages safely
        onMessage(messaging, (payload) => {
            console.log('📩 Firebase message received:', payload);
            // Handle notification display logic here
        });
    } catch (err) {
        console.error('⚠️ Firebase Messaging initialization failed', err);
    }
} else {
    console.log('⚠️ Firebase Messaging not supported in this browser / WKWebView');
}

// Request user permission safely
export const requestPermission = async () => {
    if (!messaging) {
        console.log('⚠️ Messaging not initialized. Cannot request permission.');
        return null;
    }

    try {
        const token = await getToken(messaging, {
            vapidKey: "BHcBl0eWcuydAezNbhB5NDuDufmjiTKsXwWlSJBZlEdltfxmHy7vClYVEmoRPfCt45egolfNwO_PzCYSrf1NvYc",
        });
        return token;
    } catch (error) {
        console.error("Permission denied or failed to get token", error);
        return null;
    }
};

export { messaging };
